import * as types from './mutation-types'

let defaultObject = () => ({ data: {} })

export default {
  [types.SET_FLIGHT_BLOCK] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.flightBlock = payload
  },
  [types.SET_FLIGHT_BLOCKS] (state, payload) {
    state.flightBlocks = payload.data
    state.pagination = { total: payload.total, current_page: payload.current_page }
  }
}
